// Opta shot map guide: typeIds 13 (Miss), 14 (Post), 15 (Attempt Saved), 16
// (Goal). X/Y on the event is the shot's origin. For 13/14/16 the shot
// reached the goal line, so end X is always 100 and end Y comes from
// qualifier 102 (goal-mouth y). Type 15 shots don't reach the line, so their
// endpoint comes from qualifiers 146/147 instead.
const SHOT_TYPE_IDS = [13, 14, 15, 16];
const SHOT_BLOCKED_TYPE_ID = 15;
const SHOT_GOAL_LINE_X = 100;
const SHOT_GOAL_MOUTH_Y_QUALIFIER_ID = 102;
const SHOT_END_X_QUALIFIER_ID = 146;
const SHOT_END_Y_QUALIFIER_ID = 147;

const SHOT_RESULTS = {
  13: "Miss",
  14: "Post",
  15: "Saved",
  16: "Goal",
};

function isShotMapEvent(e) {
  if (!SHOT_TYPE_IDS.includes(e?.typeId)) return false;
  if (!Number.isFinite(e?.x) || !Number.isFinite(e?.y)) return false;
  return true;
}

function getShotEnd(e) {
  if (e?.typeId === SHOT_BLOCKED_TYPE_ID) {
    return {
      endX: parseFloat(
        e.qualifier?.find((q) => q?.qualifierId === SHOT_END_X_QUALIFIER_ID)
          ?.value,
      ),
      endY: parseFloat(
        e.qualifier?.find((q) => q?.qualifierId === SHOT_END_Y_QUALIFIER_ID)
          ?.value,
      ),
    };
  }
  return {
    endX: SHOT_GOAL_LINE_X,
    endY: parseFloat(
      e.qualifier?.find((q) => q?.qualifierId === SHOT_GOAL_MOUTH_Y_QUALIFIER_ID)
        ?.value,
    ),
  };
}

export class ShotMap {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "ShotMap";
    this.scene = "Player Shot Map";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];

    let shots = options?.opta_events
      ?.filter((e) => e?.playerId === options?.player?.opta_ID)
      ?.filter(isShotMapEvent)
      ?.map((e) => {
        const { endX, endY } = getShotEnd(e);
        return {
          x: e.x,
          y: e.y,
          endX,
          endY,
          result: SHOT_RESULTS[e.typeId] || "",
        };
      });

    this.data.push({
      name: "Shots",
      value: { text: JSON.stringify(shots ?? []) },
    });

    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Title",
      value: {
        text: options.player?.title || "",
      },
    });
    this.data.push({
      name: "Shirt Number",
      value: {
        text:
          options.player?.shirt_number ??
          options.player?.opta_shirt_number ??
          "",
      },
    });
    this.data.push({
      name: "First Name",
      value: {
        text:
          options.player?.first_name ?? options.player?.opta_first_name ?? "",
      },
    });
    this.data.push({
      name: "Last Name",
      value: {
        text: options.player?.last_name ?? options.player?.opta_last_name ?? "",
      },
    });
    this.data.push({
      name: "First Name Uppercase",
      value: {
        text:
          options.player?.first_name_upper ??
          options.player?.opta_first_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase",
      value: {
        text:
          options.player?.last_name_upper ??
          options.player?.opta_last_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Full Name",
      value: {
        text:
          (options.player?.first_name ??
            options.player?.opta_first_name ??
            "") +
          " " +
          (options.player?.last_name ?? options.player?.opta_last_name ?? ""),
      },
    });
    this.data.push({
      name: "Full Name Uppercase",
      value: {
        text:
          (options.player?.first_name_upper ??
            options.player?.opta_first_name?.toUpperCase() ??
            "") +
          " " +
          (options.player?.last_name_upper ??
            options.player?.opta_last_name?.toUpperCase() ??
            ""),
      },
    });
    this.data.push({
      name: "Subtitle",
      value: {
        text: "",
      },
    });
    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name || "",
      },
    });

    this.data.push({
      name: "Goal Time",
      value: {
        text: "",
      },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge || "",
      },
    });

    if (options?.game?.home_team?._id === options.team?._id) {
      this.data.push({
        name: "Team Type",
        value: {
          text: "home",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_text"
            ] || "",
        },
      });
    } else {
      this.data.push({
        name: "Team Type",
        value: {
          text: "away",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_text"
            ] || "",
        },
      });
    }

    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
